export default Object.freeze({
  DIALOG: 'dialog',
  CARD: 'card',
})
